<app-media-grid
  [items]="items"
  [loading]="loading"
  emptyMessage="No images uploaded yet. Check back soon!"
  emptyIcon="photo_library"
></app-media-grid>
